import React from 'react';

import { SIGNATURE } from '../pen-glyph';
import { BackSheet, Check, Groove, Ink, Picture, Seal, Sheet } from './SecuredPicture.styles';

export type SecuredPictureProps = {
  className?: string;
};

/**
 * The Secured layout's picture: the signed contract as a faded line drawing. A sheet with its folded
 * corner over a second one, its lines of copy, the signature on its line, and the seal with its
 * shield, whose check is the one touch of green (the brand is secured). Decorative.
 */
export const SecuredPicture = ({ className }: SecuredPictureProps): React.ReactElement => (
  <Picture className={className} viewBox="0 0 320 230" strokeWidth="1.6" aria-hidden="true" focusable="false">
    <BackSheet x="128" y="26" width="150" height="192" rx="12" transform="rotate(8 200 120)" />
    <g transform="rotate(-3 160 115)">
      <Sheet d="M106 18h102l28 28v164a12 12 0 01-12 12H106a12 12 0 01-12-12V30a12 12 0 0112-12z" />
      <Ink d="M208 18v18a10 10 0 0010 10h18" />
      <Ink d="M112 52h56" strokeWidth="5" />
      <Ink d="M112 76h100M112 90h86M112 104h96M112 118h64" strokeWidth="2.4" />
      <Ink d="M112 178h84" strokeWidth="1.4" />
      <Ink d={SIGNATURE} transform="translate(12 60)" strokeWidth="2" />
      <g transform="translate(222 190)">
        <Seal r="23" />
        <Groove r="18" />
        <Ink d="M0-10l8.5 3.4V0c0 5.7-3.7 9.1-8.5 10.8C-4.8 9.1-8.5 5.7-8.5 0v-6.6z" strokeWidth="1.8" />
        <Check d="M-3.6.2l2.5 2.5 4.8-5" />
      </g>
    </g>
  </Picture>
);

export default SecuredPicture;
